import Store from '@ember-data/store';
import Controller from '@ember/controller';
import { service } from '@ember/service';
import { PledgeRow } from 'donor-elf-web/components/pledges-table';
import ContactsCache from 'donor-elf-web/services/contacts-cache';
import ContactsExportService, {
  type HeaderInfo,
} from 'donor-elf-web/services/contacts-export';
import FormatDateService from 'donor-elf-web/services/format-date-service';
import FileSaver from 'file-saver';
import moment from 'moment';
import Papa from 'papaparse';

export default class PledgeFulfillmentController extends Controller {
  @service declare contactsCache: ContactsCache;
  @service declare contactsExport: ContactsExportService;
  @service declare formatDateService: FormatDateService;
  @service declare store: Store;

  get actionsMenuItems() {
    return [
      {
        label: 'Download',
        svgJar: 'download',
        onClick: () => {
          this.download();
        },
      },
    ];
  }

  download = async () => {
    let rows = [];
    let headerRow = [
      'Days Overdue Group',
      'Contact',
      'Start Date',
      'End Date',
      'Frequency',
      'Amount',
      'Last Gift',
      'Next Expected Gift',
      'Days Overdue',
      'Notes',
      '---',
    ];

    rows.push(headerRow);

    const headerInfo = await this.contactsExport.addContactsHeaderColumns(
      headerRow,
      this.contactsCache.contacts,
    );
    const { ninetyDays, sixtyDays, thirtyDays, current, noGifts, ended } =
      this.model;

    let groupRows = [];
    for (let item of ninetyDays) {
      groupRows.push(
        await this.createRow(item, '90+ Days Overdue', headerInfo),
      );
    }
    rows = rows.concat(groupRows.sort(this.sortRows));

    groupRows = [];
    for (let item of sixtyDays) {
      groupRows.push(
        await this.createRow(item, '60+ Days Overdue', headerInfo),
      );
    }
    rows = rows.concat(groupRows.sort(this.sortRows));

    groupRows = [];
    for (let item of thirtyDays) {
      groupRows.push(
        await this.createRow(item, '30+ Days Overdue', headerInfo),
      );
    }
    rows = rows.concat(groupRows.sort(this.sortRows));

    groupRows = [];
    for (let item of current) {
      groupRows.push(await this.createRow(item, 'Current', headerInfo));
    }
    rows = rows.concat(groupRows.sort(this.sortRows));

    groupRows = [];
    for (let item of noGifts) {
      groupRows.push(await this.createRow(item, 'No Gifts', headerInfo));
    }
    rows = rows.concat(groupRows.sort(this.sortRows));

    groupRows = [];
    for (let item of ended) {
      groupRows.push(await this.createRow(item, 'Ended', headerInfo));
    }
    rows = rows.concat(groupRows.sort(this.sortRows));

    this.store.createRecord('contact-download').save();

    const csv = Papa.unparse(rows);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });

    FileSaver.saveAs(blob, 'pledge-fulfillment.csv', true);
  };

  async createRow(
    pledgeRow: PledgeRow,
    daysOverdueGroup: string,
    headerInfo: HeaderInfo,
  ) {
    const today = moment();
    const pledge = pledgeRow.pledge;
    const contact = this.contactsCache.getById(pledge.contactId) || {};

    let daysOverdue = today.diff(pledge.nextExpectedDonationDate, 'days');

    if (pledge.nextExpectedDonationDate) {
      if (daysOverdue < 0) {
        daysOverdue = 0;
      }
    } else {
      daysOverdue = null;
    }

    const row = [
      daysOverdueGroup,
      contact.name,
      this.formatDateService.formatForFile(pledge.startDate),
      this.formatDateService.formatForFile(pledge.endDate),
      pledge.frequencyLabel,
      pledge.amount,
      this.formatDateService.formatForFile(pledge.lastDonationDate),
      this.formatDateService.formatForFile(pledge.nextExpectedDonationDate),
      daysOverdue,
      pledge.notes,
      '',
    ];

    await this.contactsExport.addContactInfoToRow(row, contact, headerInfo);

    return row;
  }

  sortRows(a: any[], b: any[]) {
    const pledgeAOverdue = a[7];
    const pledgeBOverdue = b[7];

    if (pledgeAOverdue > pledgeBOverdue) {
      return 1;
    } else if (pledgeBOverdue > pledgeAOverdue) {
      return -1;
    } else {
      return 0;
    }
  }
}
